<app-multi-line-event-without-selector *ngIf="!withSelector" [event]="parsedEvent$ | async"
  [markets]="selectedMarket.selections" [sportId]="sportId" [showDate]="showDate" [showDetails]="showDetails"
  [isAvailable]="isAvailable">
</app-multi-line-event-without-selector>
<app-multi-line-event-with-selector *ngIf="withSelector" [event]="parsedEvent$ | async"
  [markets]="selectedMarket.selections" (toggleSelector)="clickSelector()" [isAvailable]="isAvailable">
</app-multi-line-event-with-selector>